import { render, staticRenderFns } from "./FormVcDemo.vue?vue&type=template&id=c8262ecc&scoped=true&"
import script from "./FormVcDemo.vue?vue&type=script&lang=js&"
export * from "./FormVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./FormVcDemo.vue?vue&type=style&index=0&id=c8262ecc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8262ecc",
  null
  
)

export default component.exports